import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../services/api';
import { useTenant } from '../contexts/TenantContext';

/**
 * Single React Query hook for the composite dashboard overview endpoint.
 * Replaces the previous 3-call pattern (security + compliance + enforcement).
 */
export function useDashboardOverview() {
  const { isResolved } = useTenant();

  return useQuery({
    queryKey: ['dashboardOverview'],
    queryFn: () => dashboardApi.getDashboardOverview(),
    enabled: isResolved,
    staleTime: 60_000,       // 1 minute
    refetchInterval: 300_000, // 5 minutes
  });
}
